<template>
    <div class="main_container">
        <!-- 查询部分 -->
       <div class="condition_box clearfix">
        <el-form :inline="true" :model="detileParams">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <!-- <el-form :inline="true" :model="filters"> -->
                    <el-form-item>
                        <span  class="inp_title">已撤文章题目:</span>
                    </el-form-item>
                    <el-form-item class="form_item">
                       <el-input  class="inp_item" placeholder="已撤文章题目" v-model="detileParams.articleName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span  class="inp_title">已撤文章作者:</span>
                    </el-form-item>
                    <el-form-item>
                       <el-input  class="inp_item" placeholder="已撤文章作者" v-model="detileParams.author"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                        <span  class="inp_title">发表刊物/比对库:</span>
                    </el-form-item>
                    <el-form-item>
                       <el-input  class="inp_item" placeholder="发表刊物/比对库" v-model="detileParams.publication"></el-input>
                    </el-form-item> -->
                <!-- </el-form> -->
                    <el-form-item>
                        <span  class="inp_title">撤除类型</span>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="detileParams.commitType" placeholder="请选择撤除类型">
                            <el-option
                            v-for="item in commitTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
            </el-col>
           <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form-item>
                    <span class="inp_title">申请人姓名:</span>
                </el-form-item>
                <el-form-item class="form_item">
                    <el-input  class="inp_item" placeholder="姓名" v-model="detileParams.requesterName"></el-input>
                </el-form-item>
                <el-form-item>
                    <span  class="inp_title">申请人电话:</span>
                </el-form-item>
                <el-form-item>
                    <el-input  class="inp_item" placeholder="电话" v-model="detileParams.requesterPhoneNum"></el-input>
                </el-form-item>
                <el-form-item>
                    <span  class="inp_title">所在单位:</span>
                </el-form-item>
                <el-form-item>
                    <el-input  class="inp_item" placeholder="单位" v-model="detileParams.requesterOrganisation"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form-item>
                    <span  class="inp_title">操作日期:</span>
                </el-form-item>
                <el-form-item class="form_item time_form">
                    <el-date-picker type="date" placeholder="选择日期" v-model="detileParams.OperateTimeBegin" value-format='yyyy-MM-dd'>
                    </el-date-picker>
                    至
                    <el-date-picker type="date" placeholder="选择日期" v-model="detileParams.OperateTimeEnd" value-format='yyyy-MM-dd' ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="chaxun_btn" @click="searchData">查询</el-button>
                </el-form-item>
            </el-col>
           </el-form>
       </div>
       <!-- 内容部分 -->
       <div class="table_box">
           <el-button type="primary" class="chegao_btn" style="margin-bottom:10px;" @click="ExportExcelFn">导出excel</el-button>
           <my-table :items="tableDataDetail" :headers="tableHeaderDetail" :oprateBtns="oprateBtns" :selectShow="false"  :oprateOption="oprateOption"  :listLoading="listLoadingDetail"   :totalNum="TotalNumDetail" :pageSize="detileParams.pageSize" @getTableData="getTableDataDetail">
                <template slot-scope="{props}" slot="caozuo">
                    <span class="caozuo_span" @click="getDetailPage(props.row)">查看</span>
                </template>
                <template slot-scope="{props}" slot="CheckStatusText">
                    <span>{{props.row.CheckStatusText}}</span>
                </template>
                <template slot-scope="{props}" slot="CommitType">
                    <span>{{props.row.CommitTypes}}</span>
                </template>
            </my-table>
       </div>

    </div>
</template>
<script>
import MyTable from '@/components/Table'
export default {
    //ExportExcel
    components: {
        MyTable
    },
    data(){
        return{
            // 执行撤除失败 -2, 审核失败 -1, 待审核 0, 审核处理成功 1, 执行撤除成功 2
            options:[
                {
                    value: '1',
                    label: '审核通过'

                },
                {
                    value: '-1',
                    label: '审核不通过'

                },
                {
                    value: '2',
                    label: '撤除成功'
                },
                {
                    value: '-2',
                    label: '撤除失败'

                },
                {
                    value: '1,2,-1,-2',
                    label: '全部'

                },
            ],
            commitTypeList: [{
                value: '0',
                label: '全部'
            }, {
                value: '1',
                label: '互联网资源'
            }, {
                value: '2',
                label: '联合比对库资源'
            }],
            input2:"",
            input21:"",
          //  filters:{},
            tableData3: [],
            border:true,
            currentPage1: 5,
            oprateBtns: [
                // {text: '查看', method: 'viewFn',class: 'view_btn'},
                {text: '编辑', method: 'editFn'},
            ],
            tableHeaderDetail:[
                {prop: 'ArticleName', label: '已撤文章题目'},
                {prop: 'Author', label: '已撤文章作者'},//
                // {prop: 'Publication', label: '发表刊物/比对库'},
                {prop: 'RequesterName', label: '申请人姓名',},
                {prop: 'RequesterPhoneNum', label: '申请人电话',},
                {prop: 'RequesterOrganisation', label: '所在单位'},
                {prop: 'UpdateTime', label: '操作日期'},
                {prop: 'CommitTypes', label: '撤除类型'},
                {prop: 'caozuo', label: '操作',show: 'template'},
            ],
            tableDataDetail:[],
            listLoadingDetail:true,
            TotalNumDetail:1,
            commitText: '',
            oprateOption:{
                hasOprate:false,
                oprateName:"操作",
                width:""
            },
            checkStatusSelect:"",
            detileParams:{
                commitType: '0', // 1 互联网资源 2 联合比对库资源
                checkStatus:'2',
                // checkStatusList:[],
                requesterName:"",
                requesterPhoneNum:'',
                requesterOrganisation:"",
                articleName:"",
                author:"",
                publication:"",
                OperateTimeBegin:"",
                OperateTimeEnd:"",
                pageIndex:1,//第几页
                pageSize:20//每页多少条
            },

        }
    },
    created(){
        this.getTableDataDetail();
    },
    methods:{
        ExportExcelFn(){
            var _this = this;
            _this.$api.ExportExcel(_this.detileParams).then((res, status, header, config, statusText) =>{
                // console.log("res======",res);
                if(res.data){
                    var content = res.data;
                    var blob = new Blob([content]);
                    //var fileName = res.headers("content-disposition").split(";")[1].split("filename=")[1]; //要保存的文件名称
                    var fileName = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                    var fileNameUnicode = res.headers["content-disposition"].split("filename*=")[1];
                    fileName = decodeURIComponent(fileName)
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        var elink = document.createElement("a");
                        elink.download = fileName;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                    }
                    }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    }

            })
        },
        searchData(){
           this.getTableDataDetail();
        },
        getTableDataDetail(p){
            this.listLoadingDetail = true;
            var _this = this;
            if (!p){
                p = 1;
            }
            if (!!p) {
                this.detileParams.pageIndex=p;
            }
            _this.$api.commitGetBysearchParam(this.detileParams).then(res => {
                // console.log("datalist",res);
                if(res.data&&res.data.result){
                    this.listLoadingDetail = false
                    var tableData = res.data.info.SearchList || [];
                    _this.TotalNumDetail = res.data.info.TotalNum;
                    tableData.forEach((item) => {
                        if(item.CheckStatus==0){
                            item.CheckStatusText='待审核'
                        }else if(item.CheckStatus==-2){
                            item.CheckStatusText='执行撤除失败'
                        }else if(item.CheckStatus==-1){
                            item.CheckStatusText='审核未通过'
                        }else if(item.CheckStatus==1){
                            item.CheckStatusText='审核通过'
                        }else if(item.CheckStatus==2){
                            item.CheckStatusText='执行撤除成功 '
                        }

                        if(item.CommitType==1) {
                            item.CommitTypes = '互联网资源'
                        } else {
                            item.CommitTypes = '联合比对库资源'
                        }
                    })
                    _this.tableDataDetail=tableData;
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }

            })
        },
        getDetailPage(row){
            this.$router.push({
                name: 'viewRecord',
                params: {
                    id: row.ID,
                    pageType:3,
                    type: row.CommitType,
                    row: row
                }
            })
            // this.$router.push({
            //     path:"/viewInfo",
            //     name:'撤除申请详情',
            //     params:{
            //         id:id
            //     }
            // });
        }
    }

}
</script>
<style>

 .el-input__inner{
         height: 34px;
     }
     .el-select>.el-input{
         width:204px;
     }
</style>

<style lang="scss" scoped>
    .condition_box{
        border:1px solid #DCDFE6;
        padding-top: 10px;
        // border-bottom:none;
    }
     .toolbar{
        background: transparent;
        padding: 0;
        margin: 0px;
     }
     .inp_title{
        display:inline-block;
        width:112px;
        text-align: right;
     }
    .chaxun_btn{
        height:34px;
        margin-left:200px;
        line-height:10px;
    }
    .table_box{
        margin-top:20px;
    }
    .page_box{
        margin-top:10px;
    }

</style>




// WEBPACK FOOTER //
// dataBase.vue?24f7b42f